<!-- Loading bar -->
<ngx-loading-bar [includeSpinner]="false" color="var(--bs-primary)" />

<!-- Snackbar -->
<ngx-snackbar />

<!-- Page -->
<router-outlet />
